module.exports = __webpack_public_path__ + "static/warrenty-8c2f827e647d44d42b9edc83359022b3.png";